import { css } from '@linaria/core';

const confettiColors = [
  'rgba(173, 169, 255, 1)',
  'rgba(61, 168, 122, 1)',
  'rgba(70, 200, 207, 1)',
  'rgba(202, 237, 171, 1)',
];

// Apply this to the confetti wrapper where you want the confetti to rain
export const confettiRain = css`
  @keyframes confettiRain {
    0% {
      opacity: 0.8;
      margin-top: -100vh;
      margin-left: -200px;
    }

    100% {
      opacity: 0.8;
      margin-top: 100vh;
      margin-left: 200px;
    }
  }

  .confetti {
    opacity: 0;
    position: absolute;
    width: 1rem;
    height: 1.5rem;
    animation: confettiRain 7s 60ms;
  }
`;

// Call this to make the confetti rain appear
export function createConfetti() {
  const confettiWrapper = document.getElementById('confetti-wrapper');

  if (!confettiWrapper) return;

  Array.from({ length: 200 }).forEach(() => {
    const randomRotation = Math.floor(Math.random() * 360);
    const randomWidth = Math.floor(
      Math.random() * Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    );
    const randomHeight = Math.floor(
      Math.random() * Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    );
    const randomAnimationDelay = Math.floor(Math.random() * 10);
    const randomColor = confettiColors[Math.floor(Math.random() * confettiColors.length)];

    const confetti = document.createElement('div');
    confetti.className = 'confetti';
    confetti.style.top = `${randomHeight}px`;
    confetti.style.left = `${randomWidth}px`;
    confetti.style.backgroundColor = randomColor;
    confetti.style.transform = `skew(15deg) rotate(${randomRotation}deg)`;
    confetti.style.animationDelay = `${randomAnimationDelay}s`;
    confetti.style.zIndex = '10004';

    confettiWrapper.appendChild(confetti);
  });
}
